export default "__VITE_ASSET__C$TjsSeM__"